// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__M2v8W","head":"style_head__QHuWt","rows":"style_rows__2VBW2","row":"style_row__2M4mJ"};